import { isSystemRoleAdmin } from "../utils";
import useAdminUser from "./useAdminUser";

const useCanAdminSystemRoles = () => {
  const adminUser = useAdminUser();
  return adminUser && isSystemRoleAdmin(adminUser);
};

export default useCanAdminSystemRoles;



// WEBPACK FOOTER //
// ./webAdmin/hooks/useCanAdminSystemRoles.js